import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { UsuariosService } from 'src/app/servicios/usuarios.service';
import { HeaderInfoService } from 'src/app/servicios/header-info.service';
import { ToastService } from 'src/app/servicios/toast.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-subida-masiva',
  templateUrl: './subida-masiva.component.html',
  styleUrls: ['./subida-masiva.component.scss']
})
export class SubidaMasivaComponent implements OnInit {
  unidadId: number = 0;
  selectedFile: File | null = null;
  fileName: string = '';
  cargando: boolean = false;
  procesandoArchivo: boolean = false;
  errorMessage: string = '';
  successMessage: string = '';

  // Propiedades dinámicas para la tabla de vista previa
  headers: string[] = [];
  rows: any[][] = [];

  constructor(
    private readonly location: Location,
    private usuariosService: UsuariosService,
    private headerInfoService: HeaderInfoService,
    private toastService: ToastService
  ) {
    const dataString = localStorage.getItem('data_login');
    if (dataString) {
      try {
        const data_login = JSON.parse(dataString);
        this.unidadId = data_login?.company_id || 0;
      } catch (e) {
        this.unidadId = 0;
      }
    }
  }

  ngOnInit(): void {
    this.headerInfoService.cambiarTituloPagina("SUBIDA MASIVA");
    this.headerInfoService.cambiarTituloTarjeta("Subida Masiva de Usuarios");
    this.headerInfoService.cambiarTextoTarjeta("Descarga el formato Excel, diligencia los campos y cárgalo aquí para previsualizar los datos e importarlos masivamente.");
  }

  descargarPlantilla(): void {
    if (!this.unidadId) {
      this.toastService.mostrarToast("No se pudo obtener el ID de la unidad residencial.");
      return;
    }
    this.cargando = true;
    this.usuariosService.descargarFormatoExcel(this.unidadId).subscribe({
      next: (blob: Blob) => {
        this.cargando = false;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Plantilla_Usuarios_${this.unidadId}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.toastService.mostrarToast("Plantilla descargada con éxito.");
      },
      error: (err) => {
        this.cargando = false;
        console.error('Error al descargar formato:', err);
        this.toastService.mostrarToast("Error al descargar el formato Excel.");
      }
    });
  }

  onFileChange(evt: any): void {
    const file = evt.target.files[0];
    if (!file) return;

    this.selectedFile = file;
    this.fileName = file.name;
    this.procesandoArchivo = true;
    this.errorMessage = '';
    this.successMessage = '';

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        
        // Leer como matriz de matrices (raw rows)
        const parsedData = XLSX.utils.sheet_to_json<any[]>(worksheet, { header: 1 });
        
        if (parsedData && parsedData.length > 0) {
          // Extraer la primera fila como cabeceras y quitar filas vacías
          this.headers = (parsedData[0] || []).map(h => String(h || '').trim());
          
          // Filtrar filas vacías
          this.rows = parsedData.slice(1).filter(row => 
            row && row.length > 0 && row.some(cell => cell !== null && cell !== undefined && String(cell).trim() !== '')
          );
          
          this.toastService.mostrarToast("Archivo procesado con éxito. Vista previa disponible.");
        } else {
          this.headers = [];
          this.rows = [];
          this.toastService.mostrarToast("El archivo seleccionado está vacío.");
        }
      } catch (err) {
        console.error('Error al procesar archivo Excel:', err);
        this.toastService.mostrarToast("No se pudo leer el archivo Excel. Asegúrese de que el formato sea válido.");
        this.resetFile();
      } finally {
        this.procesandoArchivo = false;
      }
    };

    reader.onerror = () => {
      this.toastService.mostrarToast("Error al leer el archivo.");
      this.procesandoArchivo = false;
    };

    reader.readAsArrayBuffer(file);
  }

  resetFile(): void {
    this.selectedFile = null;
    this.fileName = '';
    this.headers = [];
    this.rows = [];
    this.errorMessage = '';
    this.successMessage = '';
    const inputEl = document.getElementById('fileInput') as HTMLInputElement;
    if (inputEl) {
      inputEl.value = '';
    }
  }

  resetAfterSuccess(): void {
    this.selectedFile = null;
    this.fileName = '';
    this.headers = [];
    this.rows = [];
    const inputEl = document.getElementById('fileInput') as HTMLInputElement;
    if (inputEl) {
      inputEl.value = '';
    }
  }

  enviarArchivo(): void {
    if (!this.selectedFile) {
      this.toastService.mostrarToast("Por favor, seleccione primero un archivo Excel.");
      return;
    }

    this.cargando = true;
    this.errorMessage = '';
    this.successMessage = '';
    this.usuariosService.subirArchivoMasivo(this.selectedFile).subscribe({
      next: (res) => {
        this.cargando = false;
        this.successMessage = res?.message || "Usuarios importados exitosamente.";
        this.toastService.mostrarToast(this.successMessage);
        this.resetAfterSuccess();
      },
      error: (err) => {
        this.cargando = false;
        console.error('Error al subir archivo masivo:', err);
        this.errorMessage = err?.error?.data?.message || err?.error?.message || "Error al subir el archivo e importar usuarios.";
        this.toastService.mostrarToast(this.errorMessage, 10000);
      }
    });
  }

  volver(): void {
    this.location.back();
  }
}
